import React from "react";
import { Link } from 'react-router-dom';
import { withRouter } from "./react/WithRouter";

import { faEye, faMagnifyingGlassChart, faEllipsisVertical, faFileDownload, faFilter } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import DataTable from 'react-data-table-component';

import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import Spinner from 'react-bootstrap/Spinner';
import ListGroup from "react-bootstrap/ListGroup";
import Form from 'react-bootstrap/Form';

import { OverlayPanel } from 'primereact/overlaypanel';
import { MultiSelect } from 'primereact/multiselect';
import { ConfirmDialog } from 'primereact/confirmdialog';

import ControlReportDialog from "./ControlReportDialog";

import UserContext from '../context/UserContext';

class TestList extends React.Component {

	static contextType = UserContext;

	state = {	
		isLoading: false,	
		showAll: false,
		controlTestlList: [],
		selectedRiskFilter: [],
	};
	constructor() {
		super()

		this.opRef = React.createRef(null);
		//this.expandList = [];
	}

	componentDidMount() {
		this.fetchControlList();
	}


	componentDidUpdate(prevProps, prevState) {
		
	}

	fetchControlList() {
		this.setState({ isLoadingControls: true });
		fetch('api/ControlTest/GetTestList', { method: 'GET', headers: { 'Content-Type': 'application/json' } })
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				if (data.error) {
					throw (data.error);
				}	
				//console.log(data);
				const uniqueRisks = data.map((control) => control.riskName).filter((item, i, ar) => ar.indexOf(item) === i).map((risk) => { return { name: risk } });
				this.setState({ availableRisks: uniqueRisks });

				this.setState({ controlTestlList: data });
				this.setState({ isLoadingControls: false });			
			})
			.catch(error => {
				this.setState({ isLoadingControls: false });
			})
	}

	menuPopup(row) {
		return (
			<Popover id="popover-basic" className="popup-menu shadow ">
				<Popover.Body>
					<ListGroup>
						<ListGroup.Item onClick={() => { document.body.click(); }}>
							<Link to={'/ControlTest/' + row.controlID}>
								<FontAwesomeIcon icon={faEye} size="sm" /> Inspect
							</Link>
						</ListGroup.Item>
					</ListGroup>	
				</Popover.Body>				
			</Popover>
		);
	}


	customLoader() {
		return (
			<div style={{ padding: '24px' }}>
				<Spinner animation="border" />
				<div>Loading...</div>
			</div>
		);
	}

	handleCloseControlReportDialog() {
		this.setState({ modal: '' });
	}

	render() {
		const user = this.context.user;
		var filteredData;
		//console.log(this.state.controlTestlList);
		if (!this.state.showAll && user.roleList.length > 0) {
			filteredData = this.state.controlTestlList.filter(control => user.roleList.some(role => role.roleID === control.testerRoleID) &&
				(this.state.selectedRiskFilter.length === 0 || this.state.selectedRiskFilter.some(risk => control.riskName === risk.name)) 
			);
		}
		else {
			filteredData = this.state.controlTestlList.filter(
				(control => (this.state.selectedRiskFilter.length === 0 || this.state.selectedRiskFilter.some(risk => control.riskName === risk.name))
				)
			);
			//filteredData = this.state.filteredData;
		}
			
		const customStyles = {
			headRow: {
				style: {
					border: 'none',
				},
			},
			headCells: {
				style: {
					color: '#202124',
					fontSize: '14px',
				},
			},
			rows: {
				highlightOnHoverStyle: {
					backgroundColor: 'AliceBlue',
					borderBottomColor: '#FFFFFF',
					borderRadius: '25px',
					outline: '1px solid #FFFFFF',
				},
			},
		};

		const columns = [
			{
				cell: (row) => <FontAwesomeIcon icon={faMagnifyingGlassChart} style={{ backgroundColor: 'gray', color: 'white', padding: '0.3rem 0.35rem', borderRadius: '5px' }} />,
				width: '2.75rem', // custom width for icon button
				style: {
					borderBottom: '1px solid #FFFFFF',
					marginBottom: '-1px',
				},
			},
			{
				name: 'Control',
				selector: row => row.controlName,
				sortable: true,
				grow: 2,
				style: {
					color: '#202124',
					fontSize: '14px',
					fontWeight: 500,
				},
			},
			{
				name: 'Risk',
				selector: row => row.riskName,
				sortable: true,
				grow: 2,
				style: {
					color: 'rgba(0,0,0,.54)',
				},
			},
			{
				name: 'Responsible',
				selector: row => row.testerRole,
				sortable: true,
				width: '8rem',
				style: {
					color: 'rgba(0,0,0,.54)',
				},
			},
			{
				name: 'Test frequency',
				selector: row => row.testFrequency,
				sortable: true,
				width: '12rem',
				style: {
					color: 'rgba(0,0,0,.54)',
				},
			},
			{
				name: 'Last test',
				selector: row => { if (row.testStatus !== 0) { return row.testDate.split('T')[0] } else { return '' } },
				sortable: true,
				width: '8rem',
				style: {
					color: 'rgba(0,0,0,.54)',
				},
			},
			{
				cell: row => <OverlayTrigger trigger="click" placement="left" rootClose overlay={this.menuPopup(row)}>
					<Button variant="light" className="btn-circle"><FontAwesomeIcon icon={faEllipsisVertical} /></Button>
				</OverlayTrigger>,
				allowOverflow: true,
				button: true,
				width: '3rem',
			},
		];


		return (	
			<Card className="workspace-card">
				<ConfirmDialog />
				<ControlReportDialog visible={this.state.modal === 'controlReport'} onClose={this.handleCloseControlReportDialog.bind(this)} controlList={filteredData.map(r => r.controlID)} />


				<Card.Header>
					<div style={{ float: 'left' }}>
						<b>Internal Control Tests</b>
					</div>
					<div style={{ float: 'right' }}>
						<Button size='sm' id={"btn_filter"} variant="secondary" onClick={(e) => this.opRef.current.toggle(e)}><FontAwesomeIcon icon={faFilter} /></Button>
						<Button size='sm' id={"btn_filter"} variant="secondary" onClick={(e) => this.setState({ modal: 'controlReport' })} style={{ marginLeft: '0.5rem' }}><FontAwesomeIcon icon={faFileDownload} /> Control report</Button>
						
						<OverlayPanel ref={this.opRef} >
							<div className="p-field" style={{ marginBottom: '1rem' }}>
								<MultiSelect
									value={this.state.selectedRiskFilter}
									options={this.state.availableRisks}
									optionLabel="name"
									placeholder="Select risk"
									className="p-inputtext-sm w-full md:w-15rem"

									onChange={(e) => { this.setState({ selectedRiskFilter: e.value }) }}
								/>
							</div>
							<div className="p-field" style={{ marginBottom: '1rem' }}>
								<Form.Check 
									checked={!this.state.showAll}
									onChange={e => this.setState({ showAll: !e.target.checked })}
									type="switch"
									label="Show only my controls"
									reverse
								/>
							</div>
						</OverlayPanel>
					</div>
				</Card.Header>
				<Card.Body style={{ overflowX: 'auto', overflowY: 'auto', width: '100%', height: '100%', display: 'grid', margin: 0, padding: 0, whiteSpace: 'nowrap' }}>
					<DataTable
						responsive
						className="data-table"
						columns={columns}
						data={filteredData}
						customStyles={customStyles}
						progressPending={this.state.isLoadingControls}
						progressComponent={this.customLoader()}
						highlightOnHover
						pointerOnHover
						noHeader={true}
						onRowClicked={(row, event) => this.props.navigate('/ControlTest/' + row.controlID)}
						/>
				</Card.Body>
			</Card>			
		)
	}
}
export default withRouter (TestList);

